<kendo-dialog [title]="titleLabel|localizeLabel" (close)="close()" [width]="620">

    <boi-affordability-results [affordabilityResults]="data">
    </boi-affordability-results>

</kendo-dialog>